(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('cwc_home-hero--slideshow')) return;

    const track = sectionEl.querySelector('.cwc_home-hero__track');
    const slides = sectionEl.querySelectorAll('.cwc_home-hero__slide');
    const indicators = sectionEl.querySelectorAll('.cwc_home-hero__indicator');
    if (!track || slides.length < 2) return;

    // Clear any previous timer when re-initialised in the Theme Editor
    if (sectionEl._cwcHeroTimer) clearInterval(sectionEl._cwcHeroTimer);

    let current = 0;

    function setActive(index) {
      current = index;
      indicators.forEach(function (dot, i) {
        dot.classList.toggle('cwc_home-hero__indicator--active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const target = slides[index];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    indicators.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10) || 0);
        restartAutoplay();
      });
    });

    // Keep indicators in sync with swipe / scroll
    let scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current) setActive(index);
      }, 80);
    }, { passive: true });

    // Autoplay
    const autoplay = sectionEl.dataset.autoplay === 'true';
    const speed = parseInt(sectionEl.dataset.speed, 10) || 6000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function startAutoplay() {
      if (!autoplay || reduceMotion) return;
      sectionEl._cwcHeroTimer = setInterval(function () {
        goTo((current + 1) % slides.length);
      }, speed);
    }

    function stopAutoplay() {
      if (sectionEl._cwcHeroTimer) clearInterval(sectionEl._cwcHeroTimer);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    sectionEl.addEventListener('mouseenter', stopAutoplay);
    sectionEl.addEventListener('mouseleave', startAutoplay);
    sectionEl.addEventListener('focusin', stopAutoplay);
    sectionEl.addEventListener('focusout', startAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });

    setActive(0);
    startAutoplay();
  }

  function initAllSections() {
    document.querySelectorAll('.cwc_home-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.cwc_home-hero');
    if (section) initSection(section);
  });

  // Theme Editor: jump to the selected slide
  document.addEventListener('shopify:block:select', function (event) {
    const slide = event.target;
    if (!slide || !slide.classList.contains('cwc_home-hero__slide')) return;
    const track = slide.closest('.cwc_home-hero__track');
    if (track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  });
})();
